import React from 'react'
import { Table,
  TableCell,
  TableRow,
  TableHead,
  Hidden,
  Typography,
  IconButton
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import { CustomTooltip } from './CustomTooltip'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

const styles = theme => ({
  table:{
    fontSize: 14,
    "@media print":{
      display: 'none'
    }
  },
  sent:{
    fontWeight: 'bold'
  },
  unsent:{
    color: theme.palette.primary.main,
  },
  compactTableCell:{
    padding: '0px 0px 0px 15px',
    height: 15
  },
  compactTableCellAction:{
    textAlign: 'end',
    padding: '0px 0px 0px 15px !important',
    height: 15
  },
  purple:{
    color: theme.palette.primary.main,
  },
  gray:{
    color: 'gray',
  }
});

class DocPhysicalDetails extends React.Component {

  render () {
    const { classes, readDetail, sendNotificationForPhysical, role } = this.props

    let physicalDetails = <Typography className="no_print emptyTab">No hay información de envío en físico</Typography>;

    if(readDetail.filter(readD => !readD.copy).length > 0){
      physicalDetails = (
      <React.Fragment>
        <Hidden only={['xs','sm']}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow  align={"left"} style={{height:'30px'}}>
                  <TableCell className={classes.compactTableCell}>Nombre</TableCell>
                  <TableCell style={{ textAlign: 'right', paddingRight: 10 }}>Enviado</TableCell>
              </TableRow>
            </TableHead>
            <tbody>
              {readDetail.filter(readD => !readD.copy).map((user, index) => {
                return(
                  <TableRow key={user.to.name.full} className={(user.request_physical && !user.sent_physical)? classes.sent : classes.unsent }>
                    <TableCell className={classes.compactTableCell} key={user.to.name.full}>
                      {user.to.name.full}
                    </TableCell>
                    <TableCell className={classes.compactTableCellAction}>
                      <CustomTooltip  title={user.sent_physical? 'Enviado' : 'No enviado' } placement="right">
                        <div>
                          <IconButton disabled={(user.sent_physical || user.requested_physical || role !== 'owner')? true : false} onClick={() => sendNotificationForPhysical(user.to.id, index)}>
                            {
                              user.sent_physical? <CheckCircleOutline className={classes.purple} /> : <RadioButtonUncheckedIcon className={classes.gray} />
                            }
                          </IconButton>
                        </div>
                      </CustomTooltip>
                    </TableCell>
                  </TableRow>
                )
              })
            }
          </tbody>
        </Table>
       </Hidden>
      </React.Fragment>);
    }

  return (physicalDetails);

  }

}

export default withStyles(styles)(DocPhysicalDetails);



// WEBPACK FOOTER //
// ./src/components/DocPhysicalDetails.js